import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Constants } from 'src/app/constants';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { GroupiRouteService } from 'src/app/service/group-i/route-level.service';

@Component({
    selector: 'app-route-comments',
    templateUrl: './route-comments.component.html',
    styleUrls: ['./route-comments.component.scss'],
    standalone: false
})
export class RouteCommentsComponent implements OnInit {

  tierCount = "--";
  roundCount = "--";
  comments = "";
  errormsg = "";
  periodId;

  constructor(public dialogRef: MatDialogRef<RouteCommentsComponent>, @Inject(MAT_DIALOG_DATA) public dataStore: any,
    public groupirouteService: GroupiRouteService, private readonly ngxUiLoaderService : NgxUiLoaderService, private readonly constants: Constants) { }

  ngOnInit(): void {
    this.periodId = localStorage.getItem("selectedPeriodId");
    this.ngxUiLoaderService.start(this.constants.LoaderComponent);
    this.groupirouteService.getRouteComments(this.dataStore.kpiID, this.dataStore.alarmId, this.dataStore.periodid).subscribe(
      response => {
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
        if (response.length > 0) {
          this.tierCount = response[0].tierId ? response[0].tierId : "--";
          this.roundCount = response[0].round ? response[0].round : "--";
          this.comments = response[0].comments ? response[0].comments : "";
        }


      }, error => {
        console.info(error)
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
        this.errormsg = this.constants.APIErrorMessage;
      }
    );
  }
  onNoClick(): void {
    this.dialogRef.close({
      event: 'NoEvent'
    });
  }
  close(): void {
    this.dialogRef.close(
      { event: 'CloseEvent' }
    );
  }
}
